export default __webpack_public_path__ + "static/media/041-debit-card.86e95bad.png";